export default "__VITE_ASSET__CYZLca61__"